export interface ScreenWakeLockSentinel {
  readonly released: boolean;
  release: () => Promise<void>;
}

export interface ScreenWakeLockSource {
  request: (type: 'screen') => Promise<ScreenWakeLockSentinel>;
}

export interface WakeLockLease {
  readonly supported: boolean;
  readonly acquired: boolean;
  release: () => Promise<void>;
}

export async function acquireForegroundWakeLock(
  source: ScreenWakeLockSource | undefined,
): Promise<WakeLockLease> {
  if (!source) {
    return { supported: false, acquired: false, release: async () => undefined };
  }

  try {
    const sentinel = await source.request('screen');
    return {
      supported: true,
      acquired: true,
      release: async () => {
        if (!sentinel.released) await sentinel.release();
      },
    };
  } catch {
    return { supported: true, acquired: false, release: async () => undefined };
  }
}
